import type { IAPI } from '../../apiResponse';
import { getRequest } from '../../httpClient';
import type { ICollection } from '../collection-schema';
import { searchCollectionsResponseSchema } from '../searchCollections';

export async function searchCollectionsV4Api(query: string) {
  return getRequest<IAPI<ICollection[]>>({
    path: '/collections/search/v4',
    options: { params: { query } },
    schema: searchCollectionsResponseSchema,
  });
}
